import { Button } from "devextreme-react"
import React, { useState } from "react"
import { FileSignatureCriptoPro } from "./FileSignatureCriptoPro.stories"

const PopMainCert = (props) => {

    const [visible, setVisible] = useState(false)

    return (
        <div>
            {!visible &&
                <div>
                    <p>
                        Для подписания договора Вам необходимо иметь сертификат, установленный в браузере <a href="https://www.cryptopro.ru/products/cades/plugin" target="blank">плагин</a>, а также установленный на компьютере Cryptopro CSP.
                    </p>
                    {props.rezVerify.isOk ?
                        <>
                            <div dangerouslySetInnerHTML={{__html: props.rezVerify.result}}></div>
                            <Button text="Продолжить" type="default" onClick={()=>setVisible(true)}/>
                        </>
                        :
                        <>
                            <Button text="Продолжить" type="default" disabled={true}/>
                            <div
                                className="mt-2"
                                style={{color: 'red'}}
                                dangerouslySetInnerHTML={{__html: props.rezVerify.result}}
                            />
                        </>
                    }
                </div>
            }
            {visible && <FileSignatureCriptoPro files={props.files} companyKey={props.companyKey}  filePdfName={props.filePdfName} idFile={props.idFile}
                                                onSuccessSign={() => {
                                                    props.onSuccessSign();
                                                    setVisible(false)}}
            />}
        </div>
    )
}

export default PopMainCert
